let config;
if (process.env.REACT_APP_ENV === "prod") {
  config = require("./config-prod");
} else {
  config = require("./config-dev");
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/config/index.js